import './index.scss';


const TipPop = (props) => {
    return (
        <div className="tipPopBox">
            <div className="tip_container">
                <div className="tip_box">
                    <div className="close_pop" onClick={() => props.close?props.close():props.setChildShowtipflag(false)}></div>
                   {props.headerTitle &&  <div className="header-title">{props.headerTitle} </div>}
                    <div className="tip_title" style={{color:props.color?props.color:""}}>{props.title}</div>
                    <div className="tipButtonsWrap">
                         {props.confirm && <div className="tip_button" onClick={() => props.confirm?props.confirm():props.setChildShowtipflag(false)}>{props.confirmTxt || "确认"}</div>}
                         { props.cancel && <div className="tip_button" onClick={() =>{props.cancel? props.cancel(): props.setChildShowtipflag(false)}}>{props.cancelTxt || "取消"}</div>}
                    </div>
                   
                </div>
            </div>

        </div>
    )
}
export default TipPop;